export function fBedrooms(numBeds: number) {
  if (numBeds === 0) {
    return 'Studio';
  }
  if (numBeds === 1) {
    return `${numBeds} BR`;
  }
  return `${numBeds} BR`;
}
